import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.prueflauf-bemerkung-setzen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufBemerkungSetzenEffects {

    PrueflaufBemerkungSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFLAUF_BEMERKUNG_SETZEN),
        mergeMap((x: ac.PostPrueflaufBemerkungSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPrueflaufBemerkungSetzen(x.prueflaufBemerkungRequest).pipe(
                map((result: any) => {
                    return new ac.PostPrueflaufBemerkungSetzenErfolgreichAction(result, x.prueflaufBemerkungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPrueflaufBemerkungSetzenFehlerAction(error, x.prueflaufBemerkungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufCommandService);
        }
        return this.service;
    }
}
